module.exports = __webpack_public_path__ + "static/biking-lg-35202a36cfabc5e628b9f6f24f470e2a.jpg";